import React, {Component} from "react";
import {connect} from 'react-redux'
import helper from "../../../../helper/helper"
class ItemInfo extends Component {
  render() {
    const {item} = this.props
    return (
      item &&
      <table className='detail-table'>
        <tbody className='detail-tbody'>
        <tr>
          <th className='detail-th'>Mã sông suối</th>
          <td className='detail-td'>{item.maSongSuoi}</td>
        </tr>
        <tr>
          <th className='detail-th'>Tên sông, suối</th>
          <td className='detail-td'>{item.tenSongSuoi}</td>
        </tr>
        <tr>
          <th className='detail-th'>Chảy ra sông</th>
          <td className='detail-td'>{item.chayRaSong}</td>
        </tr>
        <tr>
          <th className='detail-th'>Chảy qua huyện</th>
          <td className='detail-td'>{item.tenDVHC}</td>
        </tr>
        <tr>
          <th className='detail-th'>Chiều dài (Km)</th>
          <td className='detail-td'>{item.chieuDai}</td>
        </tr>
        <tr>
          <th className='detail-th'>Dộ sâu</th>
          <td className='detail-td'>{item.doSau}</td>
        </tr>
        <tr>
          <th className='detail-th'>Diện tích lưu vực (Km2)</th>
          <td className='detail-td'>{item.dienTichLuuVuc}</td>
        </tr>
        <tr>
          <th className='detail-th'>Trữ lượng (Triệu m3)</th>
          <td className='detail-td'>{item.truLuong}</td>
        </tr>
        <tr>
          <th className='detail-th'>Chức năng sông</th>
          <td className='detail-td'>{item.chucNangSong}</td>
        </tr>
        <tr>
          <th className='detail-th'>Ghi chú</th>
          <td className='detail-td'>{item.ghiChu}</td>
        </tr>
        </tbody>
      </table>
    )
  }
}

const mapStateToProps = (state) => ({user: state.oidc.user});
export default connect(mapStateToProps)(ItemInfo);